import {
  Chip,
  ChipProps,
  CircularProgress,
  Stack,
  Theme,
  useTheme,
} from "@mui/material";

interface Props extends ChipProps {
  isLoading?: boolean;
}

export function SSChip({ isLoading, ...rest }: Props) {
  const theme = useTheme();
  const progressColor = getFontColor(rest.variant, theme);

  const renderProgress = isLoading ? (
    <Stack direction={"row"} justifyContent={"center"} alignItems={"center"}>
      <CircularProgress size={"14px"} sx={{ color: progressColor }} />
    </Stack>
  ) : (
    rest.label
  );

  return (
    <Chip
      {...rest}
      label={renderProgress}
      icon={isLoading ? undefined : rest.icon}
      disabled={isLoading}
      sx={{
        ...rest.sx,
        "&:active": { boxShadow: "none" },
      }}
    />
  );
}

function getFontColor(variant: ChipProps["variant"], theme: Theme) {
  switch (variant) {
    case "filled":
      return theme.palette.common.white;
    case "outlined":
      return theme.palette.text.primary;
    default:
      return theme.palette.text.primary;
  }
}
